import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { Prompt as Props } from './prompt.types';

/** https://www.figma.com/design/dQeQgh6sANMhWBUNtgXQNN/satsweb-components?node-id=9082-33945 */
const Prompt: React.FC<Props> = ({ links, text, title }) => (
  <div className="prompt">
    <div className="prompt__title">
      <Text
        elementName="h2"
        size={Text.sizes.large}
        theme={Text.themes.emphasis}
        tight
      >
        {title}
      </Text>
    </div>
    <div className="prompt__text">
      <Text
        elementName="p"
        size={Text.sizes.basic}
        theme={Text.themes.normal}
        tight
      >
        {text}
      </Text>
    </div>
    <div className="prompt__links">
      {links.map((entry, index) => (
        <div key={entry.href}>
          <LinkButton
            {...entry}
            variant={
              index
                ? LinkButton.variants.secondary
                : LinkButton.variants.primary
            }
          />
        </div>
      ))}
    </div>
  </div>
);

export default Prompt;
